var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderRedLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.625 3.97834C5.625 3.31936 6.12868 2.78516 6.75 2.78516H11.25C12.6424 2.78516 13.9777 3.3718 14.9623 4.41604C15.9469 5.46028 16.5 6.87656 16.5 8.35334C16.5 9.8301 15.9469 11.2464 14.9623 12.2906C13.9777 13.3349 12.6424 13.9215 11.25 13.9215H7.875V19.092C7.875 19.7509 7.37132 20.2852 6.75 20.2852C6.12868 20.2852 5.625 19.7509 5.625 19.092V3.97834ZM7.875 11.5352H11.25C12.0457 11.5352 12.8087 11.2 13.3713 10.6032C13.9339 10.0065 14.25 9.19724 14.25 8.35334C14.25 7.50946 13.9339 6.70016 13.3713 6.10345C12.8087 5.50675 12.0457 5.17152 11.25 5.17152H7.875V11.5352Z",
    fill: "#FB2047"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70446 11.8846C10.1438 11.4187 10.8562 11.4187 11.2955 11.8846L19.5455 20.6346C19.9848 21.1006 19.9848 21.8561 19.5455 22.3221C19.1062 22.788 18.3938 22.788 17.9545 22.3221L9.70446 13.5721C9.26518 13.1061 9.26518 12.3506 9.70446 11.8846Z",
    fill: "#FB2047"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5455 15.0682C19.9848 15.5342 19.9848 16.2897 19.5455 16.7556L14.2955 22.3238C13.8562 22.7897 13.1438 22.7897 12.7045 22.3238C12.2652 21.8579 12.2652 21.1023 12.7045 20.6364L17.9545 15.0682C18.3938 14.6023 19.1062 14.6023 19.5455 15.0682Z",
    fill: "#FB2047"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderRedLogo);
export default __webpack_public_path__ + "static/media/order-red-logo.6b41a06da0754179b91c0d3f82333bb6.svg";
export { ForwardRef as ReactComponent };